import { useTranslation } from 'react-i18next';

export const UpgradeRequiredBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="upgrade-required-banner pagination-layout p-t-16">
      <p className="upgrade-required-banner__text">{t('PLANS.UPGRADE_REQUIRED')}</p>
    </div>
  );
};
